<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2022-04-15 10:33:13
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-04 17:34:39
 * @FilePath: \partner.chaoyongtuan.com\src\views\secondColonelManage\components\single.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="single">
		<div class="flex-row-align-center pt-12 pb-12">
			<div class="flex-row-align-center">
				<p class="font-h4-medium yx-color-text-primary">{{ row.commission_rate }}%</p>
				<p class="yx-color-text-secondary font-h6-regular ml-4">最低佣金</p>
				<p class="font-h4-medium yx-color-text-danger ml-24" v-if="row.cos_limit_type == 2  || (row.cos_limit_type == 1 && Number(row.ad_commission_rate) > 0)">{{ row.ad_commission_rate }}%</p>
				<p class="yx-color-text-danger font-h6-regular ml-4" v-if="row.cos_limit_type == 2  || (row.cos_limit_type == 1 && Number(row.ad_commission_rate) > 0)">投放期</p>
			</div>
			<div class="flex-row-align-center line">
				<p class="font-h4-medium yx-color-text-primary">{{ row.service_rate }}%</p>
				<p class="yx-color-text-secondary font-h6-regular ml-4">服务费</p>
				<p class="font-h4-medium yx-color-text-danger ml-24" v-if="row.cos_limit_type == 2  || (row.cos_limit_type == 1 && Number(row.ad_service_rate) > 0)">{{ row.ad_service_rate }}%</p>
				<p class="yx-color-text-danger font-h6-regular ml-4" v-if="row.cos_limit_type == 2  || (row.cos_limit_type == 1 && Number(row.ad_service_rate) > 0)">投放期</p>
			</div>
			<div class="flex-row-align-center line">
				<p class="font-h4-medium yx-color-text-primary">
					<span class="mr-6">{{ row.estimated_single_sale }}</span>
					<span>每单品</span>
				</p>
				<p class="yx-color-text-secondary font-h6-regular ml-4">预估平均成绩销售额(元)</p>
			</div>
		</div>
		<div class="mt-8">
			<p class="fz-13 flex flex-align-center">
				<span class="yx-color-text-secondary">报名时间：</span>
				<span>{{ row.apply_start_time + ' - ' + row.apply_end_time }}</span>
				<span class="ml-10 mr-10">|</span><span>最短推广周期：{{ row.min_promotion_days }}</span> <span class="ml-10 mr-10">|</span
				><span>最短团长保护期：{{ row.min_exclusion_duration || '0' }}个月</span>
			</p>
			<p class="fz-13 mt-10"
				><span class="yx-color-text-secondary">招商类目：</span><span>{{ categories_limit }}</span></p
			>
			<p class="fz-13 mt-10"
				><span class="yx-color-text-secondary">报名门槛：</span
				><span>店铺类型：{{ row.shop_type_limit }} ｜ 商家体验分 >{{ row.shop_score_limit }}</span></p
			>
			<p class="fz-13 mt-10"
				><span class="yx-color-text-secondary">活动要求：</span><span>{{ row.activity_desc }}</span></p
			>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		row: {
			type: Object,
			default: () => {},
		},
	},
	computed: {
		authorize() {
			const { institution_info = {} } = this.row;
			return institution_info.authorize || '';
		},
		categories_limit() {
			const { cate_info = [] } = this.row;
			return cate_info.length ? cate_info.map(item => item.cate_name).join(',') : '';
		},
	},
};
</script>
<style lang="less" scoped>
.line::before {
	content: '';
	width: 1px;
	height: 12px;
	background-color: @color-gy4;
	margin: 0px 16px;
}
.yx-color-text-danger{
	color: #f37574;
}
</style>